import { STAKE_DB_POOL_STATE, ALLOWED_STATE_TRANSITIONS } from '@/types/stake-db';

// 상태 값을 표시 문자열로 변환
export const stakeDbStateFilter = (aData: string | number): string => {
  let re = null;
  switch (Number(aData)) {
    case STAKE_DB_POOL_STATE.WAITING:
      re = 'Waiting';
      break;
    case STAKE_DB_POOL_STATE.FUNDRAIS_ING:
      re = 'Fundraising';
      break;
    case STAKE_DB_POOL_STATE.FUNDRAIS_ING_LOCKED:
      re = 'Fundraising Locked';
      break;
    case STAKE_DB_POOL_STATE.FUNDRAIS_ING_STOPPED:
      re = 'Fundraising Stopped';
      break;
    case STAKE_DB_POOL_STATE.FUNDRAIS_ING_FAILED:
      re = 'Fundraising Failed';
      break;
    case STAKE_DB_POOL_STATE.OPERATING:
      re = 'Operating';
      break;
    case STAKE_DB_POOL_STATE.OPERATING_CLOSED:
      re = 'Operating Closed';
      break;
    case STAKE_DB_POOL_STATE.OPERATING_STOPPED:
      re = 'Operating Stopped';
      break;
    default:
      re = String(aData);
      break;
  }
  return re;
};

// 상태 셀렉트 옵션
export const stakeDbStatusSelect = [
  { value: STAKE_DB_POOL_STATE.WAITING, label: 'Waiting' },
  { value: STAKE_DB_POOL_STATE.FUNDRAIS_ING, label: 'Fundraising' },
  { value: STAKE_DB_POOL_STATE.FUNDRAIS_ING_LOCKED, label: 'Fundraising Locked' },
  { value: STAKE_DB_POOL_STATE.FUNDRAIS_ING_STOPPED, label: 'Fundraising Stopped' },
  { value: STAKE_DB_POOL_STATE.FUNDRAIS_ING_FAILED, label: 'Fundraising Failed' },
  { value: STAKE_DB_POOL_STATE.OPERATING, label: 'Operating' },
  { value: STAKE_DB_POOL_STATE.OPERATING_CLOSED, label: 'Operating Closed' },
  { value: STAKE_DB_POOL_STATE.OPERATING_STOPPED, label: 'Operating Stopped' },
];

// 현재 상태에서 전환 가능한 상태 목록 반환
export const getAvailableStateTransitions = (currentState: number) => {
  const allowedStates = ALLOWED_STATE_TRANSITIONS[currentState] || [];
  return stakeDbStatusSelect.filter((option) => allowedStates.includes(option.value));
};

// 숨김 여부 필터
export const stakeDbIsHiddenFilter = (aData: boolean | undefined): string => {
  if (aData === true) {
    return '비공개';
  }
  return '공개';
};
